<template>
  <div class="billboard" id="million-bit-billboard"
    v-on:click="clickBillboard"
    @mouseenter="onMouseEnter" 
    @mouseleave="onMouseLeave" 
    @mousemove="onMouseMove"
    v-bind:class="{'showTooltip': hovering}"
    >
    <canvas id="uploadedImg"></canvas>
    <img v-bind:src="s3ImgSrc" usemap="#linkmap" @load="onBillboardLoaded" />
    <map name="linkmap">
      <area v-for="link in links" target="_blank" alt="" title="" shape="rect" v-bind:coords="link.c" v-bind:href="link.u">
    </map>
    <div id="billboard-tooltip" :ref="'tooltip'"></div>
  </div>
</template>

<script>
/*global axios*/
import utils from '../utils';
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
const getTsPath = (path) => `${BASE_S3_BUCKET}tang/${path}?${Date.now()}`;
export default {
  name: 'tang',
  data () {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      s3ImgSrc: getTsPath('homepage.jpeg'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3PricesJson: getTsPath('prices.json'), // BASE_S3_BUCKET+'prices.json?'+Date.now(),
      s3TransactionsJson: getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0,       // To store the X coordinate of the mouse
      mouseY: 0,        // To store the Y coordinate of the mouse
      tooltipTxt: '',
    };
  },
  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    onBillboardLoaded: function() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/tang');
      }
    },
    clickBillboard: function(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.appData().canBuy) {
        return;
      }
      const { offsetX, offsetY } = e;
      if (e.target && e.target.coords) {
        const link = this.getLinkFromCoords(offsetX, offsetY);
        if (link) {
          this.saveEvent('clickBillboardTang', {
            url: link.u,
            x: offsetX,
            y: offsetY,
          });
          utils.trackEvent('clickBillboardTang', {url: link.u});
          utils.trackEvent('clickBillboardTang:'+link.u);
        }
      } else {
        utils.trackEvent('clickBillboardTang:emptySpace');
        if (!this.appData().isMobileOrTouch) {
          // Don't do this on mobile
          this.doUpload(offsetX, offsetY);
        }
      }
    },
    onMouseEnter() {
      this.hovering = true;
    },
    onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove(e) {
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      const rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (e.target && e.target.coords) {
        const { offsetX, offsetY } = e;
        const link = this.getLinkFromCoords(offsetX, offsetY);
        if (link && link.u) {
          const [x1, y1, x2, y2] = link.c.split(',');
          // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);
          this.$refs.tooltip.innerHTML = link.u;
        }
      } else {
        // console.log('Mouse over blank space');
        this.$refs.tooltip.innerHTML = 'Claim this space';
      }
      this.$refs.tooltip.style.left = `${this.mouseX}px`;
      this.$refs.tooltip.style.top = `${this.mouseY-50}px`;
      this.$refs.tooltip.style.marginLeft = `-${this.$refs.tooltip.offsetWidth/2}px`;
    },
    getLinkFromCoords: function(x, y) {
      const links = this.links;
      for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const [x1, y1, x2, y2] = link.c.split(',');
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function(t) {
      utils.toast({
        title: `${t.pixels} pixels sold!`,
        message: `To ${utils.truncateString(t.from)}<br />${t.url}`,
        img: this.s3BaseTrx+t.hash+'-crop.jpeg',
        type: "success",
        duration: 10000
      });
      utils.trackEvent('toastTransaction');
    },
    toastTransactions: function () {
      try {
        const recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
        window.toastInterval = setInterval(() => {
          if (recentTransactions.length > 0) {
            const t = recentTransactions.shift();
            const trxKey = 'toastedTrx-'+t.hash;
            if (localStorage.getItem(trxKey)) {
              return;
            }
            localStorage.setItem(trxKey, true);
            this.toastTransaction(t);
          }
        }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: async function(doReload) {
      var self = this;
      if (doReload) {
        this.s3ImgSrc = getTsPath('homepage.jpeg');
      }
      return new Promise((resolve, reject) => {
        axios.get(self.s3LinkMap)
          .then((response) => {
            window.linkMap = self.links = response.data;
            axios.get(getTsPath('prices.json'))
              .then((response) => {
                window.pricesData = self.prices = response.data;
                // if (doReload) {
                //   _.times(1024/16/2, (x) => {
                //     _.times(1024/16/2, (y) => {
                //       window.pricesData.push({x: x, y: y, p: "100"});
                //     });
                //   });
                // }
                if (false) {
                  axios.get(self.s3TransactionsJson)
                    .then((response) => {
                      self.transactions = response.data;
                      // self.toastTransaction(self.transactions[0]);
                      self.toastTransactions();

                      resolve();
                    });
                  } else {
                    resolve();
                  }
              })
              .catch(function (error) {
                console.log('Error loading '+self.s3PricesJson, error);
                reject(error);
              });
          })
          .catch(function (error) {
            console.log('Error loading '+self.s3LinkMap, error);
            reject(error);
          });
      });
    },
  },
  created: function () {
    this.fetchData();
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #uploadedImg {
    position: absolute;
    display: none;
  }
  .billboard {
    width: 1024px;
    height: 1024px;
    margin: 33px auto;
  }
  .billboard img {
    box-shadow: 0px 0px 100px #333333;
    image-rendering: pixelated;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
  .billboard.showTooltip {
    cursor: pointer;
  }
  #billboard-tooltip {
    position: absolute;
    display: none;
    background: #000;
    color: #fff;
    padding: 5px;
    border-radius: 5px;
    z-index: 1000;
    max-height: 2em;
    overflow: hidden;
  }
  .billboard.showTooltip #billboard-tooltip {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tang.vue?322ac389